// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".centered[data-v-16e63d76]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.vert_align_middle[data-v-16e63d76]{position:absolute;top:50%;transform:translateY(-50%)}.fullsizecover[data-v-16e63d76]{position:absolute;top:0;left:0;width:100%;height:100%}.full_screen_cover[data-v-16e63d76]{position:absolute;top:0;left:0;width:100vw;height:100vh}.paypal-button[data-v-16e63d76]{margin:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
